var cov_1fgm2o0a69 = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/AnimationList/AbsoluteList.tsx",
      hash = "58513569c73deab14c1547f3c4bd300053148288",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/AnimationList/AbsoluteList.tsx",
    statementMap: {
      "0": {
        start: {
          line: 16,
          column: 24
        },
        end: {
          line: 16,
          column: 25
        }
      },
      "1": {
        start: {
          line: 20,
          column: 27
        },
        end: {
          line: 20,
          column: 48
        }
      },
      "2": {
        start: {
          line: 21,
          column: 2
        },
        end: {
          line: 21,
          column: 38
        }
      },
      "3": {
        start: {
          line: 22,
          column: 2
        },
        end: {
          line: 22,
          column: 54
        }
      },
      "4": {
        start: {
          line: 23,
          column: 2
        },
        end: {
          line: 23,
          column: 36
        }
      },
      "5": {
        start: {
          line: 25,
          column: 2
        },
        end: {
          line: 27,
          column: 3
        }
      },
      "6": {
        start: {
          line: 26,
          column: 4
        },
        end: {
          line: 26,
          column: 29
        }
      },
      "7": {
        start: {
          line: 31,
          column: 2
        },
        end: {
          line: 31,
          column: 62
        }
      },
      "8": {
        start: {
          line: 31,
          column: 45
        },
        end: {
          line: 31,
          column: 62
        }
      },
      "9": {
        start: {
          line: 33,
          column: 2
        },
        end: {
          line: 35,
          column: 3
        }
      },
      "10": {
        start: {
          line: 34,
          column: 4
        },
        end: {
          line: 34,
          column: 29
        }
      },
      "11": {
        start: {
          line: 36,
          column: 2
        },
        end: {
          line: 36,
          column: 13
        }
      },
      "12": {
        start: {
          line: 39,
          column: 24
        },
        end: {
          line: 39,
          column: 109
        }
      },
      "13": {
        start: {
          line: 39,
          column: 45
        },
        end: {
          line: 39,
          column: 108
        }
      },
      "14": {
        start: {
          line: 41,
          column: 21
        },
        end: {
          line: 41,
          column: 45
        }
      },
      "15": {
        start: {
          line: 42,
          column: 23
        },
        end: {
          line: 42,
          column: 79
        }
      },
      "16": {
        start: {
          line: 43,
          column: 25
        },
        end: {
          line: 43,
          column: 81
        }
      },
      "17": {
        start: {
          line: 66,
          column: 6
        },
        end: {
          line: 66,
          column: 18
        }
      },
      "18": {
        start: {
          line: 67,
          column: 6
        },
        end: {
          line: 67,
          column: 48
        }
      },
      "19": {
        start: {
          line: 68,
          column: 6
        },
        end: {
          line: 68,
          column: 33
        }
      },
      "20": {
        start: {
          line: 68,
          column: 27
        },
        end: {
          line: 68,
          column: 33
        }
      },
      "21": {
        start: {
          line: 69,
          column: 6
        },
        end: {
          line: 69,
          column: 25
        }
      },
      "22": {
        start: {
          line: 71,
          column: 6
        },
        end: {
          line: 71,
          column: 27
        }
      },
      "23": {
        start: {
          line: 71,
          column: 17
        },
        end: {
          line: 71,
          column: 27
        }
      },
      "24": {
        start: {
          line: 72,
          column: 6
        },
        end: {
          line: 72,
          column: 42
        }
      },
      "25": {
        start: {
          line: 73,
          column: 6
        },
        end: {
          line: 73,
          column: 50
        }
      },
      "26": {
        start: {
          line: 74,
          column: 6
        },
        end: {
          line: 74,
          column: 66
        }
      },
      "27": {
        start: {
          line: 74,
          column: 26
        },
        end: {
          line: 74,
          column: 66
        }
      },
      "28": {
        start: {
          line: 75,
          column: 6
        },
        end: {
          line: 77,
          column: 7
        }
      },
      "29": {
        start: {
          line: 76,
          column: 8
        },
        end: {
          line: 76,
          column: 61
        }
      },
      "30": {
        start: {
          line: 78,
          column: 6
        },
        end: {
          line: 78,
          column: 64
        }
      },
      "31": {
        start: {
          line: 82,
          column: 6
        },
        end: {
          line: 88,
          column: 7
        }
      },
      "32": {
        start: {
          line: 83,
          column: 8
        },
        end: {
          line: 83,
          column: 44
        }
      },
      "33": {
        start: {
          line: 84,
          column: 8
        },
        end: {
          line: 84,
          column: 48
        }
      },
      "34": {
        start: {
          line: 85,
          column: 8
        },
        end: {
          line: 87,
          column: 9
        }
      },
      "35": {
        start: {
          line: 86,
          column: 10
        },
        end: {
          line: 86,
          column: 28
        }
      },
      "36": {
        start: {
          line: 89,
          column: 6
        },
        end: {
          line: 91,
          column: 7
        }
      },
      "37": {
        start: {
          line: 90,
          column: 8
        },
        end: {
          line: 90,
          column: 47
        }
      },
      "38": {
        start: {
          line: 95,
          column: 6
        },
        end: {
          line: 95,
          column: 50
        }
      },
      "39": {
        start: {
          line: 95,
          column: 29
        },
        end: {
          line: 95,
          column: 50
        }
      },
      "40": {
        start: {
          line: 96,
          column: 6
        },
        end: {
          line: 96,
          column: 65
        }
      },
      "41": {
        start: {
          line: 96,
          column: 59
        },
        end: {
          line: 96,
          column: 65
        }
      },
      "42": {
        start: {
          line: 97,
          column: 6
        },
        end: {
          line: 99,
          column: 8
        }
      },
      "43": {
        start: {
          line: 98,
          column: 8
        },
        end: {
          line: 98,
          column: 26
        }
      },
      "44": {
        start: {
          line: 103,
          column: 27
        },
        end: {
          line: 103,
          column: 37
        }
      },
      "45": {
        start: {
          line: 104,
          column: 6
        },
        end: {
          line: 104,
          column: 27
        }
      },
      "46": {
        start: {
          line: 104,
          column: 21
        },
        end: {
          line: 104,
          column: 27
        }
      },
      "47": {
        start: {
          line: 105,
          column: 6
        },
        end: {
          line: 105,
          column: 48
        }
      },
      "48": {
        start: {
          line: 106,
          column: 6
        },
        end: {
          line: 108,
          column: 7
        }
      },
      "49": {
        start: {
          line: 107,
          column: 8
        },
        end: {
          line: 107,
          column: 102
        }
      },
      "50": {
        start: {
          line: 107,
          column: 53
        },
        end: {
          line: 107,
          column: 102
        }
      },
      "51": {
        start: {
          line: 112,
          column: 6
        },
        end: {
          line: 112,
          column: 97
        }
      },
      "52": {
        start: {
          line: 116,
          column: 24
        },
        end: {
          line: 116,
          column: 34
        }
      },
      "53": {
        start: {
          line: 117,
          column: 25
        },
        end: {
          line: 117,
          column: 59
        }
      },
      "54": {
        start: {
          line: 118,
          column: 18
        },
        end: {
          line: 118,
          column: 25
        }
      },
      "55": {
        start: {
          line: 119,
          column: 41
        },
        end: {
          line: 122,
          column: 7
        }
      },
      "56": {
        start: {
          line: 123,
          column: 6
        },
        end: {
          line: 126,
          column: 7
        }
      },
      "57": {
        start: {
          line: 124,
          column: 25
        },
        end: {
          line: 124,
          column: 63
        }
      },
      "58": {
        start: {
          line: 125,
          column: 8
        },
        end: {
          line: 125,
          column: 36
        }
      },
      "59": {
        start: {
          line: 127,
          column: 6
        },
        end: {
          line: 132,
          column: 7
        }
      },
      "60": {
        start: {
          line: 128,
          column: 8
        },
        end: {
          line: 131,
          column: 20
        }
      },
      "61": {
        start: {
          line: 134,
          column: 6
        },
        end: {
          line: 136,
          column: 7
        }
      },
      "62": {
        start: {
          line: 135,
          column: 8
        },
        end: {
          line: 135,
          column: 43
        }
      },
      "63": {
        start: {
          line: 137,
          column: 24
        },
        end: {
          line: 137,
          column: 55
        }
      },
      "64": {
        start: {
          line: 138,
          column: 31
        },
        end: {
          line: 138,
          column: 52
        }
      },
      "65": {
        start: {
          line: 139,
          column: 28
        },
        end: {
          line: 139,
          column: 96
        }
      },
      "66": {
        start: {
          line: 140,
          column: 28
        },
        end: {
          line: 140,
          column: 65
        }
      },
      "67": {
        start: {
          line: 141,
          column: 30
        },
        end: {
          line: 144,
          column: 7
        }
      },
      "68": {
        start: {
          line: 145,
          column: 6
        },
        end: {
          line: 145,
          column: 40
        }
      },
      "69": {
        start: {
          line: 146,
          column: 6
        },
        end: {
          line: 146,
          column: 44
        }
      },
      "70": {
        start: {
          line: 148,
          column: 6
        },
        end: {
          line: 173,
          column: 7
        }
      },
      "71": {
        start: {
          line: 149,
          column: 8
        },
        end: {
          line: 149,
          column: 74
        }
      },
      "72": {
        start: {
          line: 150,
          column: 8
        },
        end: {
          line: 153,
          column: 9
        }
      },
      "73": {
        start: {
          line: 151,
          column: 10
        },
        end: {
          line: 151,
          column: 69
        }
      },
      "74": {
        start: {
          line: 152,
          column: 10
        },
        end: {
          line: 152,
          column: 29
        }
      },
      "75": {
        start: {
          line: 154,
          column: 8
        },
        end: {
          line: 158,
          column: 9
        }
      },
      "76": {
        start: {
          line: 155,
          column: 10
        },
        end: {
          line: 155,
          column: 86
        }
      },
      "77": {
        start: {
          line: 157,
          column: 10
        },
        end: {
          line: 157,
          column: 78
        }
      },
      "78": {
        start: {
          line: 159,
          column: 13
        },
        end: {
          line: 173,
          column: 7
        }
      },
      "79": {
        start: {
          line: 160,
          column: 23
        },
        end: {
          line: 160,
          column: 42
        }
      },
      "80": {
        start: {
          line: 161,
          column: 8
        },
        end: {
          line: 166,
          column: 9
        }
      },
      "81": {
        start: {
          line: 162,
          column: 10
        },
        end: {
          line: 162,
          column: 76
        }
      },
      "82": {
        start: {
          line: 164,
          column: 10
        },
        end: {
          line: 164,
          column: 112
        }
      },
      "83": {
        start: {
          line: 165,
          column: 10
        },
        end: {
          line: 165,
          column: 29
        }
      },
      "84": {
        start: {
          line: 167,
          column: 8
        },
        end: {
          line: 172,
          column: 9
        }
      },
      "85": {
        start: {
          line: 168,
          column: 10
        },
        end: {
          line: 168,
          column: 93
        }
      },
      "86": {
        start: {
          line: 170,
          column: 10
        },
        end: {
          line: 170,
          column: 90
        }
      },
      "87": {
        start: {
          line: 171,
          column: 10
        },
        end: {
          line: 171,
          column: 47
        }
      },
      "88": {
        start: {
          line: 174,
          column: 6
        },
        end: {
          line: 174,
          column: 18
        }
      },
      "89": {
        start: {
          line: 178,
          column: 54
        },
        end: {
          line: 178,
          column: 64
        }
      },
      "90": {
        start: {
          line: 179,
          column: 25
        },
        end: {
          line: 179,
          column: 57
        }
      },
      "91": {
        start: {
          line: 180,
          column: 6
        },
        end: {
          line: 180,
          column: 35
        }
      },
      "92": {
        start: {
          line: 180,
          column: 18
        },
        end: {
          line: 180,
          column: 35
        }
      },
      "93": {
        start: {
          line: 181,
          column: 18
        },
        end: {
          line: 181,
          column: 20
        }
      },
      "94": {
        start: {
          line: 182,
          column: 6
        },
        end: {
          line: 195,
          column: 7
        }
      },
      "95": {
        start: {
          line: 183,
          column: 21
        },
        end: {
          line: 183,
          column: 58
        }
      },
      "96": {
        start: {
          line: 184,
          column: 32
        },
        end: {
          line: 184,
          column: 90
        }
      },
      "97": {
        start: {
          line: 186,
          column: 8
        },
        end: {
          line: 193,
          column: 9
        }
      },
      "98": {
        start: {
          line: 192,
          column: 10
        },
        end: {
          line: 192,
          column: 56
        }
      },
      "99": {
        start: {
          line: 194,
          column: 8
        },
        end: {
          line: 194,
          column: 38
        }
      },
      "100": {
        start: {
          line: 197,
          column: 6
        },
        end: {
          line: 197,
          column: 64
        }
      },
      "101": {
        start: {
          line: 197,
          column: 47
        },
        end: {
          line: 197,
          column: 64
        }
      },
      "102": {
        start: {
          line: 199,
          column: 6
        },
        end: {
          line: 199,
          column: 28
        }
      },
      "103": {
        start: {
          line: 200,
          column: 6
        },
        end: {
          line: 200,
          column: 29
        }
      },
      "104": {
        start: {
          line: 204,
          column: 6
        },
        end: {
          line: 206,
          column: 7
        }
      },
      "105": {
        start: {
          line: 205,
          column: 8
        },
        end: {
          line: 205,
          column: 26
        }
      },
      "106": {
        start: {
          line: 210,
          column: 27
        },
        end: {
          line: 210,
          column: 37
        }
      },
      "107": {
        start: {
          line: 211,
          column: 20
        },
        end: {
          line: 211,
          column: 25
        }
      },
      "108": {
        start: {
          line: 212,
          column: 6
        },
        end: {
          line: 214,
          column: 7
        }
      },
      "109": {
        start: {
          line: 213,
          column: 8
        },
        end: {
          line: 213,
          column: 22
        }
      },
      "110": {
        start: {
          line: 215,
          column: 6
        },
        end: {
          line: 217,
          column: 7
        }
      },
      "111": {
        start: {
          line: 216,
          column: 8
        },
        end: {
          line: 216,
          column: 26
        }
      },
      "112": {
        start: {
          line: 218,
          column: 6
        },
        end: {
          line: 218,
          column: 20
        }
      },
      "113": {
        start: {
          line: 222,
          column: 39
        },
        end: {
          line: 222,
          column: 49
        }
      },
      "114": {
        start: {
          line: 223,
          column: 6
        },
        end: {
          line: 223,
          column: 65
        }
      },
      "115": {
        start: {
          line: 223,
          column: 59
        },
        end: {
          line: 223,
          column: 65
        }
      },
      "116": {
        start: {
          line: 224,
          column: 20
        },
        end: {
          line: 224,
          column: 39
        }
      },
      "117": {
        start: {
          line: 225,
          column: 18
        },
        end: {
          line: 225,
          column: 99
        }
      },
      "118": {
        start: {
          line: 226,
          column: 28
        },
        end: {
          line: 226,
          column: 71
        }
      },
      "119": {
        start: {
          line: 227,
          column: 30
        },
        end: {
          line: 227,
          column: 65
        }
      },
      "120": {
        start: {
          line: 229,
          column: 6
        },
        end: {
          line: 241,
          column: 7
        }
      },
      "121": {
        start: {
          line: 230,
          column: 8
        },
        end: {
          line: 235,
          column: 9
        }
      },
      "122": {
        start: {
          line: 232,
          column: 10
        },
        end: {
          line: 232,
          column: 25
        }
      },
      "123": {
        start: {
          line: 234,
          column: 10
        },
        end: {
          line: 234,
          column: 58
        }
      },
      "124": {
        start: {
          line: 236,
          column: 13
        },
        end: {
          line: 241,
          column: 7
        }
      },
      "125": {
        start: {
          line: 238,
          column: 8
        },
        end: {
          line: 238,
          column: 23
        }
      },
      "126": {
        start: {
          line: 240,
          column: 8
        },
        end: {
          line: 240,
          column: 119
        }
      },
      "127": {
        start: {
          line: 242,
          column: 6
        },
        end: {
          line: 242,
          column: 48
        }
      },
      "128": {
        start: {
          line: 242,
          column: 42
        },
        end: {
          line: 242,
          column: 48
        }
      },
      "129": {
        start: {
          line: 243,
          column: 6
        },
        end: {
          line: 243,
          column: 26
        }
      },
      "130": {
        start: {
          line: 244,
          column: 6
        },
        end: {
          line: 246,
          column: 8
        }
      },
      "131": {
        start: {
          line: 250,
          column: 6
        },
        end: {
          line: 250,
          column: 19
        }
      },
      "132": {
        start: {
          line: 268,
          column: 10
        },
        end: {
          line: 268,
          column: 20
        }
      },
      "133": {
        start: {
          line: 269,
          column: 6
        },
        end: {
          line: 272,
          column: 7
        }
      },
      "134": {
        start: {
          line: 270,
          column: 23
        },
        end: {
          line: 270,
          column: 66
        }
      },
      "135": {
        start: {
          line: 271,
          column: 8
        },
        end: {
          line: 271,
          column: 56
        }
      },
      "136": {
        start: {
          line: 271,
          column: 35
        },
        end: {
          line: 271,
          column: 56
        }
      },
      "137": {
        start: {
          line: 274,
          column: 25
        },
        end: {
          line: 274,
          column: 115
        }
      },
      "138": {
        start: {
          line: 275,
          column: 6
        },
        end: {
          line: 275,
          column: 94
        }
      },
      "139": {
        start: {
          line: 279,
          column: 28
        },
        end: {
          line: 279,
          column: 38
        }
      },
      "140": {
        start: {
          line: 280,
          column: 6
        },
        end: {
          line: 282,
          column: 8
        }
      },
      "141": {
        start: {
          line: 281,
          column: 8
        },
        end: {
          line: 281,
          column: 37
        }
      },
      "142": {
        start: {
          line: 283,
          column: 6
        },
        end: {
          line: 285,
          column: 7
        }
      },
      "143": {
        start: {
          line: 284,
          column: 8
        },
        end: {
          line: 284,
          column: 32
        }
      },
      "144": {
        start: {
          line: 286,
          column: 6
        },
        end: {
          line: 286,
          column: 38
        }
      },
      "145": {
        start: {
          line: 286,
          column: 27
        },
        end: {
          line: 286,
          column: 38
        }
      },
      "146": {
        start: {
          line: 303,
          column: 10
        },
        end: {
          line: 303,
          column: 20
        }
      },
      "147": {
        start: {
          line: 304,
          column: 25
        },
        end: {
          line: 304,
          column: 88
        }
      },
      "148": {
        start: {
          line: 305,
          column: 31
        },
        end: {
          line: 305,
          column: 106
        }
      },
      "149": {
        start: {
          line: 306,
          column: 6
        },
        end: {
          line: 306,
          column: 41
        }
      },
      "150": {
        start: {
          line: 307,
          column: 25
        },
        end: {
          line: 312,
          column: 7
        }
      },
      "151": {
        start: {
          line: 313,
          column: 6
        },
        end: {
          line: 313,
          column: 111
        }
      },
      "152": {
        start: {
          line: 313,
          column: 48
        },
        end: {
          line: 313,
          column: 111
        }
      },
      "153": {
        start: {
          line: 314,
          column: 6
        },
        end: {
          line: 317,
          column: 7
        }
      },
      "154": {
        start: {
          line: 321,
          column: 2
        },
        end: {
          line: 324,
          column: 55
        }
      }
    },
    fnMap: {
      "0": {
        name: "initRoot",
        decl: {
          start: {
            line: 19,
            column: 9
          },
          end: {
            line: 19,
            column: 17
          }
        },
        loc: {
          start: {
            line: 19,
            column: 41
          },
          end: {
            line: 28,
            column: 1
          }
        },
        line: 19
      },
      "1": {
        name: "getRoot",
        decl: {
          start: {
            line: 30,
            column: 9
          },
          end: {
            line: 30,
            column: 16
          }
        },
        loc: {
          start: {
            line: 30,
            column: 40
          },
          end: {
            line: 37,
            column: 1
          }
        },
        line: 30
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 39,
            column: 24
          },
          end: {
            line: 39,
            column: 25
          }
        },
        loc: {
          start: {
            line: 39,
            column: 45
          },
          end: {
            line: 39,
            column: 108
          }
        },
        line: 39
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 45,
            column: 15
          },
          end: {
            line: 45,
            column: 16
          }
        },
        loc: {
          start: {
            line: 45,
            column: 63
          },
          end: {
            line: 325,
            column: 1
          }
        },
        line: 45
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 65,
            column: 4
          },
          end: {
            line: 65,
            column: 5
          }
        },
        loc: {
          start: {
            line: 65,
            column: 38
          },
          end: {
            line: 79,
            column: 5
          }
        },
        line: 65
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 81,
            column: 4
          },
          end: {
            line: 81,
            column: 5
          }
        },
        loc: {
          start: {
            line: 81,
            column: 24
          },
          end: {
            line: 92,
            column: 5
          }
        },
        line: 81
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 94,
            column: 4
          },
          end: {
            line: 94,
            column: 5
          }
        },
        loc: {
          start: {
            line: 94,
            column: 49
          },
          end: {
            line: 100,
            column: 5
          }
        },
        line: 94
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 97,
            column: 17
          },
          end: {
            line: 97,
            column: 18
          }
        },
        loc: {
          start: {
            line: 97,
            column: 23
          },
          end: {
            line: 99,
            column: 7
          }
        },
        line: 97
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 102,
            column: 4
          },
          end: {
            line: 102,
            column: 5
          }
        },
        loc: {
          start: {
            line: 102,
            column: 27
          },
          end: {
            line: 109,
            column: 5
          }
        },
        line: 102
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 111,
            column: 4
          },
          end: {
            line: 111,
            column: 5
          }
        },
        loc: {
          start: {
            line: 111,
            column: 40
          },
          end: {
            line: 113,
            column: 5
          }
        },
        line: 111
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 115,
            column: 4
          },
          end: {
            line: 115,
            column: 5
          }
        },
        loc: {
          start: {
            line: 115,
            column: 31
          },
          end: {
            line: 175,
            column: 5
          }
        },
        line: 115
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 177,
            column: 4
          },
          end: {
            line: 177,
            column: 5
          }
        },
        loc: {
          start: {
            line: 177,
            column: 15
          },
          end: {
            line: 201,
            column: 5
          }
        },
        line: 177
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 203,
            column: 4
          },
          end: {
            line: 203,
            column: 5
          }
        },
        loc: {
          start: {
            line: 203,
            column: 24
          },
          end: {
            line: 207,
            column: 5
          }
        },
        line: 203
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 209,
            column: 4
          },
          end: {
            line: 209,
            column: 5
          }
        },
        loc: {
          start: {
            line: 209,
            column: 14
          },
          end: {
            line: 219,
            column: 5
          }
        },
        line: 209
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 221,
            column: 4
          },
          end: {
            line: 221,
            column: 5
          }
        },
        loc: {
          start: {
            line: 221,
            column: 35
          },
          end: {
            line: 247,
            column: 5
          }
        },
        line: 221
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 249,
            column: 4
          },
          end: {
            line: 249,
            column: 5
          }
        },
        loc: {
          start: {
            line: 249,
            column: 32
          },
          end: {
            line: 251,
            column: 5
          }
        },
        line: 249
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 253,
            column: 4
          },
          end: {
            line: 253,
            column: 5
          }
        },
        loc: {
          start: {
            line: 253,
            column: 17
          },
          end: {
            line: 276,
            column: 5
          }
        },
        line: 253
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 278,
            column: 4
          },
          end: {
            line: 278,
            column: 5
          }
        },
        loc: {
          start: {
            line: 278,
            column: 13
          },
          end: {
            line: 318,
            column: 5
          }
        },
        line: 278
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 280,
            column: 17
          },
          end: {
            line: 280,
            column: 18
          }
        },
        loc: {
          start: {
            line: 280,
            column: 23
          },
          end: {
            line: 282,
            column: 7
          }
        },
        line: 280
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 22,
            column: 37
          },
          end: {
            line: 22,
            column: 53
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 22,
            column: 37
          },
          end: {
            line: 22,
            column: 44
          }
        }, {
          start: {
            line: 22,
            column: 48
          },
          end: {
            line: 22,
            column: 53
          }
        }],
        line: 22
      },
      "1": {
        loc: {
          start: {
            line: 25,
            column: 2
          },
          end: {
            line: 27,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 25,
            column: 2
          },
          end: {
            line: 27,
            column: 3
          }
        }, {
          start: {
            line: 25,
            column: 2
          },
          end: {
            line: 27,
            column: 3
          }
        }],
        line: 25
      },
      "2": {
        loc: {
          start: {
            line: 25,
            column: 6
          },
          end: {
            line: 25,
            column: 48
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 25,
            column: 6
          },
          end: {
            line: 25,
            column: 13
          }
        }, {
          start: {
            line: 25,
            column: 17
          },
          end: {
            line: 25,
            column: 48
          }
        }],
        line: 25
      },
      "3": {
        loc: {
          start: {
            line: 31,
            column: 2
          },
          end: {
            line: 31,
            column: 62
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 31,
            column: 2
          },
          end: {
            line: 31,
            column: 62
          }
        }, {
          start: {
            line: 31,
            column: 2
          },
          end: {
            line: 31,
            column: 62
          }
        }],
        line: 31
      },
      "4": {
        loc: {
          start: {
            line: 31,
            column: 6
          },
          end: {
            line: 31,
            column: 43
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 31,
            column: 6
          },
          end: {
            line: 31,
            column: 11
          }
        }, {
          start: {
            line: 31,
            column: 15
          },
          end: {
            line: 31,
            column: 43
          }
        }],
        line: 31
      },
      "5": {
        loc: {
          start: {
            line: 33,
            column: 2
          },
          end: {
            line: 35,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 33,
            column: 2
          },
          end: {
            line: 35,
            column: 3
          }
        }, {
          start: {
            line: 33,
            column: 2
          },
          end: {
            line: 35,
            column: 3
          }
        }],
        line: 33
      },
      "6": {
        loc: {
          start: {
            line: 33,
            column: 6
          },
          end: {
            line: 33,
            column: 48
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 33,
            column: 6
          },
          end: {
            line: 33,
            column: 13
          }
        }, {
          start: {
            line: 33,
            column: 17
          },
          end: {
            line: 33,
            column: 48
          }
        }],
        line: 33
      },
      "7": {
        loc: {
          start: {
            line: 39,
            column: 45
          },
          end: {
            line: 39,
            column: 108
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 39,
            column: 53
          },
          end: {
            line: 39,
            column: 79
          }
        }, {
          start: {
            line: 39,
            column: 82
          },
          end: {
            line: 39,
            column: 108
          }
        }],
        line: 39
      },
      "8": {
        loc: {
          start: {
            line: 68,
            column: 6
          },
          end: {
            line: 68,
            column: 33
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 68,
            column: 6
          },
          end: {
            line: 68,
            column: 33
          }
        }, {
          start: {
            line: 68,
            column: 6
          },
          end: {
            line: 68,
            column: 33
          }
        }],
        line: 68
      },
      "9": {
        loc: {
          start: {
            line: 71,
            column: 6
          },
          end: {
            line: 71,
            column: 27
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 71,
            column: 6
          },
          end: {
            line: 71,
            column: 27
          }
        }, {
          start: {
            line: 71,
            column: 6
          },
          end: {
            line: 71,
            column: 27
          }
        }],
        line: 71
      },
      "10": {
        loc: {
          start: {
            line: 74,
            column: 6
          },
          end: {
            line: 74,
            column: 66
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 74,
            column: 6
          },
          end: {
            line: 74,
            column: 66
          }
        }, {
          start: {
            line: 74,
            column: 6
          },
          end: {
            line: 74,
            column: 66
          }
        }],
        line: 74
      },
      "11": {
        loc: {
          start: {
            line: 75,
            column: 6
          },
          end: {
            line: 77,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 75,
            column: 6
          },
          end: {
            line: 77,
            column: 7
          }
        }, {
          start: {
            line: 75,
            column: 6
          },
          end: {
            line: 77,
            column: 7
          }
        }],
        line: 75
      },
      "12": {
        loc: {
          start: {
            line: 82,
            column: 6
          },
          end: {
            line: 88,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 82,
            column: 6
          },
          end: {
            line: 88,
            column: 7
          }
        }, {
          start: {
            line: 82,
            column: 6
          },
          end: {
            line: 88,
            column: 7
          }
        }],
        line: 82
      },
      "13": {
        loc: {
          start: {
            line: 82,
            column: 10
          },
          end: {
            line: 82,
            column: 48
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 82,
            column: 10
          },
          end: {
            line: 82,
            column: 29
          }
        }, {
          start: {
            line: 82,
            column: 33
          },
          end: {
            line: 82,
            column: 48
          }
        }],
        line: 82
      },
      "14": {
        loc: {
          start: {
            line: 85,
            column: 8
          },
          end: {
            line: 87,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 85,
            column: 8
          },
          end: {
            line: 87,
            column: 9
          }
        }, {
          start: {
            line: 85,
            column: 8
          },
          end: {
            line: 87,
            column: 9
          }
        }],
        line: 85
      },
      "15": {
        loc: {
          start: {
            line: 89,
            column: 6
          },
          end: {
            line: 91,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 89,
            column: 6
          },
          end: {
            line: 91,
            column: 7
          }
        }, {
          start: {
            line: 89,
            column: 6
          },
          end: {
            line: 91,
            column: 7
          }
        }],
        line: 89
      },
      "16": {
        loc: {
          start: {
            line: 95,
            column: 6
          },
          end: {
            line: 95,
            column: 50
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 95,
            column: 6
          },
          end: {
            line: 95,
            column: 50
          }
        }, {
          start: {
            line: 95,
            column: 6
          },
          end: {
            line: 95,
            column: 50
          }
        }],
        line: 95
      },
      "17": {
        loc: {
          start: {
            line: 96,
            column: 6
          },
          end: {
            line: 96,
            column: 65
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 96,
            column: 6
          },
          end: {
            line: 96,
            column: 65
          }
        }, {
          start: {
            line: 96,
            column: 6
          },
          end: {
            line: 96,
            column: 65
          }
        }],
        line: 96
      },
      "18": {
        loc: {
          start: {
            line: 104,
            column: 6
          },
          end: {
            line: 104,
            column: 27
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 104,
            column: 6
          },
          end: {
            line: 104,
            column: 27
          }
        }, {
          start: {
            line: 104,
            column: 6
          },
          end: {
            line: 104,
            column: 27
          }
        }],
        line: 104
      },
      "19": {
        loc: {
          start: {
            line: 106,
            column: 6
          },
          end: {
            line: 108,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 106,
            column: 6
          },
          end: {
            line: 108,
            column: 7
          }
        }, {
          start: {
            line: 106,
            column: 6
          },
          end: {
            line: 108,
            column: 7
          }
        }],
        line: 106
      },
      "20": {
        loc: {
          start: {
            line: 107,
            column: 8
          },
          end: {
            line: 107,
            column: 102
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 107,
            column: 8
          },
          end: {
            line: 107,
            column: 102
          }
        }, {
          start: {
            line: 107,
            column: 8
          },
          end: {
            line: 107,
            column: 102
          }
        }],
        line: 107
      },
      "21": {
        loc: {
          start: {
            line: 107,
            column: 12
          },
          end: {
            line: 107,
            column: 51
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 107,
            column: 12
          },
          end: {
            line: 107,
            column: 24
          }
        }, {
          start: {
            line: 107,
            column: 28
          },
          end: {
            line: 107,
            column: 51
          }
        }],
        line: 107
      },
      "22": {
        loc: {
          start: {
            line: 112,
            column: 13
          },
          end: {
            line: 112,
            column: 97
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 112,
            column: 57
          },
          end: {
            line: 112,
            column: 78
          }
        }, {
          start: {
            line: 112,
            column: 81
          },
          end: {
            line: 112,
            column: 97
          }
        }],
        line: 112
      },
      "23": {
        loc: {
          start: {
            line: 123,
            column: 6
          },
          end: {
            line: 126,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 123,
            column: 6
          },
          end: {
            line: 126,
            column: 7
          }
        }, {
          start: {
            line: 123,
            column: 6
          },
          end: {
            line: 126,
            column: 7
          }
        }],
        line: 123
      },
      "24": {
        loc: {
          start: {
            line: 124,
            column: 25
          },
          end: {
            line: 124,
            column: 63
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 124,
            column: 43
          },
          end: {
            line: 124,
            column: 53
          }
        }, {
          start: {
            line: 124,
            column: 56
          },
          end: {
            line: 124,
            column: 63
          }
        }],
        line: 124
      },
      "25": {
        loc: {
          start: {
            line: 127,
            column: 6
          },
          end: {
            line: 132,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 127,
            column: 6
          },
          end: {
            line: 132,
            column: 7
          }
        }, {
          start: {
            line: 127,
            column: 6
          },
          end: {
            line: 132,
            column: 7
          }
        }],
        line: 127
      },
      "26": {
        loc: {
          start: {
            line: 134,
            column: 6
          },
          end: {
            line: 136,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 134,
            column: 6
          },
          end: {
            line: 136,
            column: 7
          }
        }, {
          start: {
            line: 134,
            column: 6
          },
          end: {
            line: 136,
            column: 7
          }
        }],
        line: 134
      },
      "27": {
        loc: {
          start: {
            line: 139,
            column: 28
          },
          end: {
            line: 139,
            column: 96
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 139,
            column: 68
          },
          end: {
            line: 139,
            column: 84
          }
        }, {
          start: {
            line: 139,
            column: 87
          },
          end: {
            line: 139,
            column: 96
          }
        }],
        line: 139
      },
      "28": {
        loc: {
          start: {
            line: 139,
            column: 28
          },
          end: {
            line: 139,
            column: 65
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 139,
            column: 28
          },
          end: {
            line: 139,
            column: 51
          }
        }, {
          start: {
            line: 139,
            column: 55
          },
          end: {
            line: 139,
            column: 65
          }
        }],
        line: 139
      },
      "29": {
        loc: {
          start: {
            line: 148,
            column: 6
          },
          end: {
            line: 173,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 148,
            column: 6
          },
          end: {
            line: 173,
            column: 7
          }
        }, {
          start: {
            line: 148,
            column: 6
          },
          end: {
            line: 173,
            column: 7
          }
        }],
        line: 148
      },
      "30": {
        loc: {
          start: {
            line: 150,
            column: 8
          },
          end: {
            line: 153,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 150,
            column: 8
          },
          end: {
            line: 153,
            column: 9
          }
        }, {
          start: {
            line: 150,
            column: 8
          },
          end: {
            line: 153,
            column: 9
          }
        }],
        line: 150
      },
      "31": {
        loc: {
          start: {
            line: 154,
            column: 8
          },
          end: {
            line: 158,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 154,
            column: 8
          },
          end: {
            line: 158,
            column: 9
          }
        }, {
          start: {
            line: 154,
            column: 8
          },
          end: {
            line: 158,
            column: 9
          }
        }],
        line: 154
      },
      "32": {
        loc: {
          start: {
            line: 159,
            column: 13
          },
          end: {
            line: 173,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 159,
            column: 13
          },
          end: {
            line: 173,
            column: 7
          }
        }, {
          start: {
            line: 159,
            column: 13
          },
          end: {
            line: 173,
            column: 7
          }
        }],
        line: 159
      },
      "33": {
        loc: {
          start: {
            line: 161,
            column: 8
          },
          end: {
            line: 166,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 161,
            column: 8
          },
          end: {
            line: 166,
            column: 9
          }
        }, {
          start: {
            line: 161,
            column: 8
          },
          end: {
            line: 166,
            column: 9
          }
        }],
        line: 161
      },
      "34": {
        loc: {
          start: {
            line: 167,
            column: 8
          },
          end: {
            line: 172,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 167,
            column: 8
          },
          end: {
            line: 172,
            column: 9
          }
        }, {
          start: {
            line: 167,
            column: 8
          },
          end: {
            line: 172,
            column: 9
          }
        }],
        line: 167
      },
      "35": {
        loc: {
          start: {
            line: 180,
            column: 6
          },
          end: {
            line: 180,
            column: 35
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 180,
            column: 6
          },
          end: {
            line: 180,
            column: 35
          }
        }, {
          start: {
            line: 180,
            column: 6
          },
          end: {
            line: 180,
            column: 35
          }
        }],
        line: 180
      },
      "36": {
        loc: {
          start: {
            line: 182,
            column: 6
          },
          end: {
            line: 195,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 182,
            column: 6
          },
          end: {
            line: 195,
            column: 7
          }
        }, {
          start: {
            line: 182,
            column: 6
          },
          end: {
            line: 195,
            column: 7
          }
        }],
        line: 182
      },
      "37": {
        loc: {
          start: {
            line: 184,
            column: 32
          },
          end: {
            line: 184,
            column: 90
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 184,
            column: 48
          },
          end: {
            line: 184,
            column: 85
          }
        }, {
          start: {
            line: 184,
            column: 88
          },
          end: {
            line: 184,
            column: 90
          }
        }],
        line: 184
      },
      "38": {
        loc: {
          start: {
            line: 186,
            column: 8
          },
          end: {
            line: 193,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 186,
            column: 8
          },
          end: {
            line: 193,
            column: 9
          }
        }, {
          start: {
            line: 186,
            column: 8
          },
          end: {
            line: 193,
            column: 9
          }
        }],
        line: 186
      },
      "39": {
        loc: {
          start: {
            line: 187,
            column: 10
          },
          end: {
            line: 190,
            column: 38
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 187,
            column: 10
          },
          end: {
            line: 187,
            column: 38
          }
        }, {
          start: {
            line: 188,
            column: 10
          },
          end: {
            line: 188,
            column: 38
          }
        }, {
          start: {
            line: 189,
            column: 10
          },
          end: {
            line: 189,
            column: 38
          }
        }, {
          start: {
            line: 190,
            column: 10
          },
          end: {
            line: 190,
            column: 38
          }
        }],
        line: 187
      },
      "40": {
        loc: {
          start: {
            line: 197,
            column: 6
          },
          end: {
            line: 197,
            column: 64
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 197,
            column: 6
          },
          end: {
            line: 197,
            column: 64
          }
        }, {
          start: {
            line: 197,
            column: 6
          },
          end: {
            line: 197,
            column: 64
          }
        }],
        line: 197
      },
      "41": {
        loc: {
          start: {
            line: 204,
            column: 6
          },
          end: {
            line: 206,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 204,
            column: 6
          },
          end: {
            line: 206,
            column: 7
          }
        }, {
          start: {
            line: 204,
            column: 6
          },
          end: {
            line: 206,
            column: 7
          }
        }],
        line: 204
      },
      "42": {
        loc: {
          start: {
            line: 212,
            column: 6
          },
          end: {
            line: 214,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 212,
            column: 6
          },
          end: {
            line: 214,
            column: 7
          }
        }, {
          start: {
            line: 212,
            column: 6
          },
          end: {
            line: 214,
            column: 7
          }
        }],
        line: 212
      },
      "43": {
        loc: {
          start: {
            line: 212,
            column: 10
          },
          end: {
            line: 212,
            column: 51
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 212,
            column: 10
          },
          end: {
            line: 212,
            column: 18
          }
        }, {
          start: {
            line: 212,
            column: 22
          },
          end: {
            line: 212,
            column: 51
          }
        }],
        line: 212
      },
      "44": {
        loc: {
          start: {
            line: 215,
            column: 6
          },
          end: {
            line: 217,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 215,
            column: 6
          },
          end: {
            line: 217,
            column: 7
          }
        }, {
          start: {
            line: 215,
            column: 6
          },
          end: {
            line: 217,
            column: 7
          }
        }],
        line: 215
      },
      "45": {
        loc: {
          start: {
            line: 223,
            column: 6
          },
          end: {
            line: 223,
            column: 65
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 223,
            column: 6
          },
          end: {
            line: 223,
            column: 65
          }
        }, {
          start: {
            line: 223,
            column: 6
          },
          end: {
            line: 223,
            column: 65
          }
        }],
        line: 223
      },
      "46": {
        loc: {
          start: {
            line: 223,
            column: 10
          },
          end: {
            line: 223,
            column: 57
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 223,
            column: 10
          },
          end: {
            line: 223,
            column: 18
          }
        }, {
          start: {
            line: 223,
            column: 22
          },
          end: {
            line: 223,
            column: 28
          }
        }, {
          start: {
            line: 223,
            column: 33
          },
          end: {
            line: 223,
            column: 46
          }
        }, {
          start: {
            line: 223,
            column: 50
          },
          end: {
            line: 223,
            column: 56
          }
        }],
        line: 223
      },
      "47": {
        loc: {
          start: {
            line: 225,
            column: 18
          },
          end: {
            line: 225,
            column: 99
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 225,
            column: 19
          },
          end: {
            line: 225,
            column: 32
          }
        }, {
          start: {
            line: 225,
            column: 36
          },
          end: {
            line: 225,
            column: 73
          }
        }, {
          start: {
            line: 225,
            column: 78
          },
          end: {
            line: 225,
            column: 99
          }
        }],
        line: 225
      },
      "48": {
        loc: {
          start: {
            line: 226,
            column: 28
          },
          end: {
            line: 226,
            column: 71
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 226,
            column: 28
          },
          end: {
            line: 226,
            column: 46
          }
        }, {
          start: {
            line: 226,
            column: 50
          },
          end: {
            line: 226,
            column: 71
          }
        }],
        line: 226
      },
      "49": {
        loc: {
          start: {
            line: 227,
            column: 30
          },
          end: {
            line: 227,
            column: 65
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 227,
            column: 30
          },
          end: {
            line: 227,
            column: 50
          }
        }, {
          start: {
            line: 227,
            column: 54
          },
          end: {
            line: 227,
            column: 65
          }
        }],
        line: 227
      },
      "50": {
        loc: {
          start: {
            line: 229,
            column: 6
          },
          end: {
            line: 241,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 229,
            column: 6
          },
          end: {
            line: 241,
            column: 7
          }
        }, {
          start: {
            line: 229,
            column: 6
          },
          end: {
            line: 241,
            column: 7
          }
        }],
        line: 229
      },
      "51": {
        loc: {
          start: {
            line: 230,
            column: 8
          },
          end: {
            line: 235,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 230,
            column: 8
          },
          end: {
            line: 235,
            column: 9
          }
        }, {
          start: {
            line: 230,
            column: 8
          },
          end: {
            line: 235,
            column: 9
          }
        }],
        line: 230
      },
      "52": {
        loc: {
          start: {
            line: 230,
            column: 12
          },
          end: {
            line: 230,
            column: 43
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 230,
            column: 12
          },
          end: {
            line: 230,
            column: 19
          }
        }, {
          start: {
            line: 230,
            column: 23
          },
          end: {
            line: 230,
            column: 43
          }
        }],
        line: 230
      },
      "53": {
        loc: {
          start: {
            line: 236,
            column: 13
          },
          end: {
            line: 241,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 236,
            column: 13
          },
          end: {
            line: 241,
            column: 7
          }
        }, {
          start: {
            line: 236,
            column: 13
          },
          end: {
            line: 241,
            column: 7
          }
        }],
        line: 236
      },
      "54": {
        loc: {
          start: {
            line: 236,
            column: 17
          },
          end: {
            line: 236,
            column: 49
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 236,
            column: 17
          },
          end: {
            line: 236,
            column: 25
          }
        }, {
          start: {
            line: 236,
            column: 29
          },
          end: {
            line: 236,
            column: 49
          }
        }],
        line: 236
      },
      "55": {
        loc: {
          start: {
            line: 240,
            column: 82
          },
          end: {
            line: 240,
            column: 118
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 240,
            column: 82
          },
          end: {
            line: 240,
            column: 101
          }
        }, {
          start: {
            line: 240,
            column: 105
          },
          end: {
            line: 240,
            column: 118
          }
        }],
        line: 240
      },
      "56": {
        loc: {
          start: {
            line: 242,
            column: 6
          },
          end: {
            line: 242,
            column: 48
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 242,
            column: 6
          },
          end: {
            line: 242,
            column: 48
          }
        }, {
          start: {
            line: 242,
            column: 6
          },
          end: {
            line: 242,
            column: 48
          }
        }],
        line: 242
      },
      "57": {
        loc: {
          start: {
            line: 263,
            column: 8
          },
          end: {
            line: 263,
            column: 18
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 263,
            column: 16
          },
          end: {
            line: 263,
            column: 18
          }
        }],
        line: 263
      },
      "58": {
        loc: {
          start: {
            line: 269,
            column: 6
          },
          end: {
            line: 272,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 269,
            column: 6
          },
          end: {
            line: 272,
            column: 7
          }
        }, {
          start: {
            line: 269,
            column: 6
          },
          end: {
            line: 272,
            column: 7
          }
        }],
        line: 269
      },
      "59": {
        loc: {
          start: {
            line: 271,
            column: 8
          },
          end: {
            line: 271,
            column: 56
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 271,
            column: 8
          },
          end: {
            line: 271,
            column: 56
          }
        }, {
          start: {
            line: 271,
            column: 8
          },
          end: {
            line: 271,
            column: 56
          }
        }],
        line: 271
      },
      "60": {
        loc: {
          start: {
            line: 274,
            column: 50
          },
          end: {
            line: 274,
            column: 114
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 274,
            column: 71
          },
          end: {
            line: 274,
            column: 102
          }
        }, {
          start: {
            line: 274,
            column: 105
          },
          end: {
            line: 274,
            column: 114
          }
        }],
        line: 274
      },
      "61": {
        loc: {
          start: {
            line: 283,
            column: 6
          },
          end: {
            line: 285,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 283,
            column: 6
          },
          end: {
            line: 285,
            column: 7
          }
        }, {
          start: {
            line: 283,
            column: 6
          },
          end: {
            line: 285,
            column: 7
          }
        }],
        line: 283
      },
      "62": {
        loc: {
          start: {
            line: 286,
            column: 6
          },
          end: {
            line: 286,
            column: 38
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 286,
            column: 6
          },
          end: {
            line: 286,
            column: 38
          }
        }, {
          start: {
            line: 286,
            column: 6
          },
          end: {
            line: 286,
            column: 38
          }
        }],
        line: 286
      },
      "63": {
        loc: {
          start: {
            line: 305,
            column: 31
          },
          end: {
            line: 305,
            column: 106
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 305,
            column: 45
          },
          end: {
            line: 305,
            column: 60
          }
        }, {
          start: {
            line: 305,
            column: 63
          },
          end: {
            line: 305,
            column: 106
          }
        }],
        line: 305
      },
      "64": {
        loc: {
          start: {
            line: 311,
            column: 8
          },
          end: {
            line: 311,
            column: 72
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 311,
            column: 29
          },
          end: {
            line: 311,
            column: 60
          }
        }, {
          start: {
            line: 311,
            column: 63
          },
          end: {
            line: 311,
            column: 72
          }
        }],
        line: 311
      },
      "65": {
        loc: {
          start: {
            line: 313,
            column: 6
          },
          end: {
            line: 313,
            column: 111
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 313,
            column: 6
          },
          end: {
            line: 313,
            column: 111
          }
        }, {
          start: {
            line: 313,
            column: 6
          },
          end: {
            line: 313,
            column: 111
          }
        }],
        line: 313
      },
      "66": {
        loc: {
          start: {
            line: 313,
            column: 10
          },
          end: {
            line: 313,
            column: 46
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 313,
            column: 10
          },
          end: {
            line: 313,
            column: 16
          }
        }, {
          start: {
            line: 313,
            column: 20
          },
          end: {
            line: 313,
            column: 46
          }
        }],
        line: 313
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0,
      "90": 0,
      "91": 0,
      "92": 0,
      "93": 0,
      "94": 0,
      "95": 0,
      "96": 0,
      "97": 0,
      "98": 0,
      "99": 0,
      "100": 0,
      "101": 0,
      "102": 0,
      "103": 0,
      "104": 0,
      "105": 0,
      "106": 0,
      "107": 0,
      "108": 0,
      "109": 0,
      "110": 0,
      "111": 0,
      "112": 0,
      "113": 0,
      "114": 0,
      "115": 0,
      "116": 0,
      "117": 0,
      "118": 0,
      "119": 0,
      "120": 0,
      "121": 0,
      "122": 0,
      "123": 0,
      "124": 0,
      "125": 0,
      "126": 0,
      "127": 0,
      "128": 0,
      "129": 0,
      "130": 0,
      "131": 0,
      "132": 0,
      "133": 0,
      "134": 0,
      "135": 0,
      "136": 0,
      "137": 0,
      "138": 0,
      "139": 0,
      "140": 0,
      "141": 0,
      "142": 0,
      "143": 0,
      "144": 0,
      "145": 0,
      "146": 0,
      "147": 0,
      "148": 0,
      "149": 0,
      "150": 0,
      "151": 0,
      "152": 0,
      "153": 0,
      "154": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0],
      "29": [0, 0],
      "30": [0, 0],
      "31": [0, 0],
      "32": [0, 0],
      "33": [0, 0],
      "34": [0, 0],
      "35": [0, 0],
      "36": [0, 0],
      "37": [0, 0],
      "38": [0, 0],
      "39": [0, 0, 0, 0],
      "40": [0, 0],
      "41": [0, 0],
      "42": [0, 0],
      "43": [0, 0],
      "44": [0, 0],
      "45": [0, 0],
      "46": [0, 0, 0, 0],
      "47": [0, 0, 0],
      "48": [0, 0],
      "49": [0, 0],
      "50": [0, 0],
      "51": [0, 0],
      "52": [0, 0],
      "53": [0, 0],
      "54": [0, 0],
      "55": [0, 0],
      "56": [0, 0],
      "57": [0],
      "58": [0, 0],
      "59": [0, 0],
      "60": [0, 0],
      "61": [0, 0],
      "62": [0, 0],
      "63": [0, 0],
      "64": [0, 0],
      "65": [0, 0],
      "66": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _objectWithoutProperties from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _slicedToArray from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/AnimationList/AbsoluteList.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import classnames from 'classnames';
import shallowEqual from '../utils/shallowEqual';
import { compose } from '../utils/func';
import { scrollConsumer } from '../Scroll/context';
import { listClass } from './styles';
import { docSize } from '../utils/dom/document';
import { getRTLPosition } from '../utils/strings';
import zIndexConsumer from '../Modal/context';
import { isRTL, getDefaultContainer } from '../config';
import { addZoomListener, removeZoomListener } from '../utils/zoom';
import { isInDocument } from '../utils/dom/isInDocument';
var PICKER_V_MARGIN = (cov_1fgm2o0a69.s[0]++, 4);
var root;

function initRoot(element) {
  cov_1fgm2o0a69.f[0]++;
  var defaultContainer = (cov_1fgm2o0a69.s[1]++, getDefaultContainer());
  cov_1fgm2o0a69.s[2]++;
  root = document.createElement('div');
  cov_1fgm2o0a69.s[3]++;
  root.className = listClass('root', (cov_1fgm2o0a69.b[0][0]++, isRTL()) && (cov_1fgm2o0a69.b[0][1]++, 'rtl'));
  cov_1fgm2o0a69.s[4]++;
  defaultContainer.appendChild(root);
  cov_1fgm2o0a69.s[5]++;

  if ((cov_1fgm2o0a69.b[2][0]++, element) && (cov_1fgm2o0a69.b[2][1]++, isInDocument(element) === false)) {
    cov_1fgm2o0a69.b[1][0]++;
    cov_1fgm2o0a69.s[6]++;
    root.appendChild(element);
  } else {
    cov_1fgm2o0a69.b[1][1]++;
  }
}

function getRoot(element) {
  cov_1fgm2o0a69.f[1]++;
  cov_1fgm2o0a69.s[7]++;

  if ((cov_1fgm2o0a69.b[4][0]++, !root) || (cov_1fgm2o0a69.b[4][1]++, isInDocument(root) === false)) {
    cov_1fgm2o0a69.b[3][0]++;
    cov_1fgm2o0a69.s[8]++;
    initRoot(element);
  } else {
    cov_1fgm2o0a69.b[3][1]++;
  }

  cov_1fgm2o0a69.s[9]++;

  if ((cov_1fgm2o0a69.b[6][0]++, element) && (cov_1fgm2o0a69.b[6][1]++, isInDocument(element) === false)) {
    cov_1fgm2o0a69.b[5][0]++;
    cov_1fgm2o0a69.s[10]++;
    root.appendChild(element);
  } else {
    cov_1fgm2o0a69.b[5][1]++;
  }

  cov_1fgm2o0a69.s[11]++;
  return root;
}

cov_1fgm2o0a69.s[12]++;

var getOverDocStyle = function getOverDocStyle(right) {
  cov_1fgm2o0a69.f[2]++;
  cov_1fgm2o0a69.s[13]++;
  return right ? (cov_1fgm2o0a69.b[7][0]++, {
    left: 0,
    right: 'auto'
  }) : (cov_1fgm2o0a69.b[7][1]++, {
    right: 0,
    left: 'auto'
  });
};

var listPosition = (cov_1fgm2o0a69.s[14]++, ['drop-down', 'drop-up']);
var pickerPosition = (cov_1fgm2o0a69.s[15]++, ['left-bottom', 'left-top', 'right-bottom', 'right-top']);
var dropdownPosition = (cov_1fgm2o0a69.s[16]++, ['bottom-left', 'bottom-right', 'top-left', 'top-right']);
export default function (List) {
  cov_1fgm2o0a69.f[3]++;

  var AbsoluteList =
  /*#__PURE__*/
  function (_Component) {
    _inherits(AbsoluteList, _Component);

    var _super = _createSuper2(AbsoluteList);

    function AbsoluteList(props) {
      var _this;

      _classCallCheck(this, AbsoluteList);

      cov_1fgm2o0a69.f[4]++;
      cov_1fgm2o0a69.s[17]++;
      _this = _super.call(this, props);
      _this.state = {
        overdoc: false
      };
      _this.lastStyle = void 0;
      _this.container = void 0;
      _this.element = void 0;
      _this.ajustdoc = void 0;
      _this.containerRect = void 0;
      _this.containerScroll = void 0;
      _this.el = void 0;
      cov_1fgm2o0a69.s[18]++;
      _this.handleRef = _this.handleRef.bind(_assertThisInitialized(_this));
      cov_1fgm2o0a69.s[19]++;

      if (!props.absolute) {
        cov_1fgm2o0a69.b[8][0]++;
        cov_1fgm2o0a69.s[20]++;
        return _possibleConstructorReturn(_this);
      } else {
        cov_1fgm2o0a69.b[8][1]++;
      }

      cov_1fgm2o0a69.s[21]++;
      _this.lastStyle = {};
      cov_1fgm2o0a69.s[22]++;

      if (!root) {
        cov_1fgm2o0a69.b[9][0]++;
        cov_1fgm2o0a69.s[23]++;
        initRoot();
      } else {
        cov_1fgm2o0a69.b[9][1]++;
      }

      cov_1fgm2o0a69.s[24]++;
      _this.container = _this.getContainer();
      cov_1fgm2o0a69.s[25]++;
      _this.element = document.createElement('div');
      cov_1fgm2o0a69.s[26]++;

      if (_this.container) {
        cov_1fgm2o0a69.b[10][0]++;
        cov_1fgm2o0a69.s[27]++;

        _this.container.appendChild(_this.element);
      } else {
        cov_1fgm2o0a69.b[10][1]++;
      }

      cov_1fgm2o0a69.s[28]++;

      if (props.getResetPosition) {
        cov_1fgm2o0a69.b[11][0]++;
        cov_1fgm2o0a69.s[29]++;
        props.getResetPosition(_this.resetPosition.bind(_assertThisInitialized(_this)));
      } else {
        cov_1fgm2o0a69.b[11][1]++;
      }

      cov_1fgm2o0a69.s[30]++;
      _this.zoomChangeHandler = _this.zoomChangeHandler.bind(_assertThisInitialized(_this));
      return _this;
    }

    _createClass(AbsoluteList, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        cov_1fgm2o0a69.f[5]++;
        cov_1fgm2o0a69.s[31]++;

        if ((cov_1fgm2o0a69.b[13][0]++, this.props.absolute) && (cov_1fgm2o0a69.b[13][1]++, !this.container)) {
          cov_1fgm2o0a69.b[12][0]++;
          cov_1fgm2o0a69.s[32]++;
          this.container = this.getContainer();
          cov_1fgm2o0a69.s[33]++;
          this.container.appendChild(this.element);
          cov_1fgm2o0a69.s[34]++;

          if (this.props.focus) {
            cov_1fgm2o0a69.b[14][0]++;
            cov_1fgm2o0a69.s[35]++;
            this.forceUpdate();
          } else {
            cov_1fgm2o0a69.b[14][1]++;
          }
        } else {
          cov_1fgm2o0a69.b[12][1]++;
        }

        cov_1fgm2o0a69.s[36]++;

        if (this.props.absolute) {
          cov_1fgm2o0a69.b[15][0]++;
          cov_1fgm2o0a69.s[37]++;
          addZoomListener(this.zoomChangeHandler);
        } else {
          cov_1fgm2o0a69.b[15][1]++;
        }
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        var _this2 = this;

        cov_1fgm2o0a69.f[6]++;
        cov_1fgm2o0a69.s[38]++;

        if (!this.props.focus) {
          cov_1fgm2o0a69.b[16][0]++;
          cov_1fgm2o0a69.s[39]++;
          this.ajustdoc = false;
        } else {
          cov_1fgm2o0a69.b[16][1]++;
        }

        cov_1fgm2o0a69.s[40]++;

        if (shallowEqual(prevProps.value, this.props.value)) {
          cov_1fgm2o0a69.b[17][0]++;
          cov_1fgm2o0a69.s[41]++;
          return;
        } else {
          cov_1fgm2o0a69.b[17][1]++;
        }

        cov_1fgm2o0a69.s[42]++;
        setTimeout(function () {
          cov_1fgm2o0a69.f[7]++;
          cov_1fgm2o0a69.s[43]++;

          _this2.forceUpdate();
        });
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        cov_1fgm2o0a69.f[8]++;

        var _ref = (cov_1fgm2o0a69.s[44]++, this.props),
            absolute = _ref.absolute;

        cov_1fgm2o0a69.s[45]++;

        if (!absolute) {
          cov_1fgm2o0a69.b[18][0]++;
          cov_1fgm2o0a69.s[46]++;
          return;
        } else {
          cov_1fgm2o0a69.b[18][1]++;
        }

        cov_1fgm2o0a69.s[47]++;
        removeZoomListener(this.zoomChangeHandler);
        cov_1fgm2o0a69.s[48]++;

        if (this.container) {
          cov_1fgm2o0a69.b[19][0]++;
          cov_1fgm2o0a69.s[49]++;

          if ((cov_1fgm2o0a69.b[21][0]++, this.element) && (cov_1fgm2o0a69.b[21][1]++, this.element.parentNode)) {
            cov_1fgm2o0a69.b[20][0]++;
            cov_1fgm2o0a69.s[50]++;
            this.element.parentNode.removeChild(this.element);
          } else {
            cov_1fgm2o0a69.b[20][1]++;
          }
        } else {
          cov_1fgm2o0a69.b[19][1]++;
        }
      }
    }, {
      key: "getContainer",
      value: function getContainer(element) {
        cov_1fgm2o0a69.f[9]++;
        cov_1fgm2o0a69.s[51]++;
        return typeof this.props.absolute === 'function' ? (cov_1fgm2o0a69.b[22][0]++, this.props.absolute()) : (cov_1fgm2o0a69.b[22][1]++, getRoot(element));
      }
    }, {
      key: "getPosition",
      value: function getPosition(rect) {
        cov_1fgm2o0a69.f[10]++;

        var _ref2 = (cov_1fgm2o0a69.s[52]++, this.props),
            fixed = _ref2.fixed;

        var _ref3 = (cov_1fgm2o0a69.s[53]++, this.props),
            position = _ref3.position;

        var rtl = (cov_1fgm2o0a69.s[54]++, isRTL());
        var style = (cov_1fgm2o0a69.s[55]++, {
          position: 'absolute',
          right: 'auto'
        });
        cov_1fgm2o0a69.s[56]++;

        if (fixed) {
          cov_1fgm2o0a69.b[23][0]++;
          var widthKey = (cov_1fgm2o0a69.s[57]++, fixed === 'min' ? (cov_1fgm2o0a69.b[24][0]++, 'minWidth') : (cov_1fgm2o0a69.b[24][1]++, 'width'));
          cov_1fgm2o0a69.s[58]++;
          style[widthKey] = rect.width;
        } else {
          cov_1fgm2o0a69.b[23][1]++;
        }

        cov_1fgm2o0a69.s[59]++;

        if (dropdownPosition.includes(position)) {
          cov_1fgm2o0a69.b[25][0]++;
          cov_1fgm2o0a69.s[60]++;
          position = position.split('-').reverse().join('-');
        } else {
          cov_1fgm2o0a69.b[25][1]++;
        }

        cov_1fgm2o0a69.s[61]++;

        if (rtl) {
          cov_1fgm2o0a69.b[26][0]++;
          cov_1fgm2o0a69.s[62]++;
          position = getRTLPosition(position);
        } else {
          cov_1fgm2o0a69.b[26][1]++;
        }

        var container = (cov_1fgm2o0a69.s[63]++, this.getContainer(this.element));
        var defaultContainer = (cov_1fgm2o0a69.s[64]++, getDefaultContainer());
        var rootContainer = (cov_1fgm2o0a69.s[65]++, (cov_1fgm2o0a69.b[28][0]++, container === getRoot()) || (cov_1fgm2o0a69.b[28][1]++, !container) ? (cov_1fgm2o0a69.b[27][0]++, defaultContainer) : (cov_1fgm2o0a69.b[27][1]++, container));
        var containerRect = (cov_1fgm2o0a69.s[66]++, rootContainer.getBoundingClientRect());
        var containerScroll = (cov_1fgm2o0a69.s[67]++, {
          left: rootContainer.scrollLeft,
          top: rootContainer.scrollTop
        });
        cov_1fgm2o0a69.s[68]++;
        this.containerRect = containerRect;
        cov_1fgm2o0a69.s[69]++;
        this.containerScroll = containerScroll;
        cov_1fgm2o0a69.s[70]++;

        if (listPosition.includes(position)) {
          cov_1fgm2o0a69.b[29][0]++;
          cov_1fgm2o0a69.s[71]++;
          style.left = rect.left - containerRect.left + containerScroll.left;
          cov_1fgm2o0a69.s[72]++;

          if (isRTL()) {
            cov_1fgm2o0a69.b[30][0]++;
            cov_1fgm2o0a69.s[73]++;
            style.right = containerRect.width - rect.width - style.left;
            cov_1fgm2o0a69.s[74]++;
            style.left = 'auto';
          } else {
            cov_1fgm2o0a69.b[30][1]++;
          }

          cov_1fgm2o0a69.s[75]++;

          if (position === 'drop-down') {
            cov_1fgm2o0a69.b[31][0]++;
            cov_1fgm2o0a69.s[76]++;
            style.top = rect.top - containerRect.top + rect.height + containerScroll.top;
          } else {
            cov_1fgm2o0a69.b[31][1]++;
            cov_1fgm2o0a69.s[77]++;
            style.bottom = -(rect.top - containerRect.top + containerScroll.top);
          }
        } else {
          cov_1fgm2o0a69.b[29][1]++;
          cov_1fgm2o0a69.s[78]++;

          if (pickerPosition.includes(position)) {
            cov_1fgm2o0a69.b[32][0]++;

            var _ref4 = (cov_1fgm2o0a69.s[79]++, position.split('-')),
                _ref5 = _slicedToArray(_ref4, 2),
                h = _ref5[0],
                v = _ref5[1];

            cov_1fgm2o0a69.s[80]++;

            if (h === 'left') {
              cov_1fgm2o0a69.b[33][0]++;
              cov_1fgm2o0a69.s[81]++;
              style.left = rect.left - containerRect.left + containerScroll.left;
            } else {
              cov_1fgm2o0a69.b[33][1]++;
              cov_1fgm2o0a69.s[82]++;
              style.right = containerRect.width - rect.width - rect.left + containerRect.left - containerScroll.left;
              cov_1fgm2o0a69.s[83]++;
              style.left = 'auto';
            }

            cov_1fgm2o0a69.s[84]++;

            if (v === 'bottom') {
              cov_1fgm2o0a69.b[34][0]++;
              cov_1fgm2o0a69.s[85]++;
              style.top = rect.bottom - containerRect.top + containerScroll.top + PICKER_V_MARGIN;
            } else {
              cov_1fgm2o0a69.b[34][1]++;
              cov_1fgm2o0a69.s[86]++;
              style.top = rect.top - containerRect.top + containerScroll.top - PICKER_V_MARGIN;
              cov_1fgm2o0a69.s[87]++;
              style.transform = 'translateY(-100%)';
            }
          } else {
            cov_1fgm2o0a69.b[32][1]++;
          }
        }

        cov_1fgm2o0a69.s[88]++;
        return style;
      }
    }, {
      key: "getStyle",
      value: function getStyle() {
        cov_1fgm2o0a69.f[11]++;

        var _ref6 = (cov_1fgm2o0a69.s[89]++, this.props),
            parentElement = _ref6.parentElement,
            scrollElement = _ref6.scrollElement,
            focus = _ref6.focus;

        var lazyResult = (cov_1fgm2o0a69.s[90]++, {
          focus: focus,
          style: this.lastStyle
        });
        cov_1fgm2o0a69.s[91]++;

        if (!focus) {
          cov_1fgm2o0a69.b[35][0]++;
          cov_1fgm2o0a69.s[92]++;
          return lazyResult;
        } else {
          cov_1fgm2o0a69.b[35][1]++;
        }

        var style = (cov_1fgm2o0a69.s[93]++, {});
        cov_1fgm2o0a69.s[94]++;

        if (parentElement) {
          cov_1fgm2o0a69.b[36][0]++;
          var rect = (cov_1fgm2o0a69.s[95]++, parentElement.getBoundingClientRect());
          var scrollRect = (cov_1fgm2o0a69.s[96]++, scrollElement ? (cov_1fgm2o0a69.b[37][0]++, scrollElement.getBoundingClientRect()) : (cov_1fgm2o0a69.b[37][1]++, {}));
          cov_1fgm2o0a69.s[97]++;

          if ((cov_1fgm2o0a69.b[39][0]++, rect.bottom < scrollRect.top) || (cov_1fgm2o0a69.b[39][1]++, rect.top > scrollRect.bottom) || (cov_1fgm2o0a69.b[39][2]++, rect.right < scrollRect.left) || (cov_1fgm2o0a69.b[39][3]++, rect.left > scrollRect.right)) {
            cov_1fgm2o0a69.b[38][0]++;
            cov_1fgm2o0a69.s[98]++;
            return {
              focus: false,
              style: this.lastStyle
            };
          } else {
            cov_1fgm2o0a69.b[38][1]++;
          }

          cov_1fgm2o0a69.s[99]++;
          style = this.getPosition(rect);
        } else {
          cov_1fgm2o0a69.b[36][1]++;
        }

        cov_1fgm2o0a69.s[100]++;

        if (shallowEqual(style, this.lastStyle)) {
          cov_1fgm2o0a69.b[40][0]++;
          cov_1fgm2o0a69.s[101]++;
          return lazyResult;
        } else {
          cov_1fgm2o0a69.b[40][1]++;
        }

        cov_1fgm2o0a69.s[102]++;
        this.lastStyle = style;
        cov_1fgm2o0a69.s[103]++;
        return {
          focus: focus,
          style: style
        };
      }
    }, {
      key: "zoomChangeHandler",
      value: function zoomChangeHandler() {
        cov_1fgm2o0a69.f[12]++;
        cov_1fgm2o0a69.s[104]++;

        if (this.props.focus) {
          cov_1fgm2o0a69.b[41][0]++;
          cov_1fgm2o0a69.s[105]++;
          this.forceUpdate();
        } else {
          cov_1fgm2o0a69.b[41][1]++;
        }
      }
    }, {
      key: "isRight",
      value: function isRight() {
        cov_1fgm2o0a69.f[13]++;

        var _ref7 = (cov_1fgm2o0a69.s[106]++, this.props),
            position = _ref7.position;

        var isRight = (cov_1fgm2o0a69.s[107]++, false);
        cov_1fgm2o0a69.s[108]++;

        if ((cov_1fgm2o0a69.b[43][0]++, position) && (cov_1fgm2o0a69.b[43][1]++, position.indexOf('right') > 1)) {
          cov_1fgm2o0a69.b[42][0]++;
          cov_1fgm2o0a69.s[109]++;
          isRight = true;
        } else {
          cov_1fgm2o0a69.b[42][1]++;
        }

        cov_1fgm2o0a69.s[110]++;

        if (isRTL()) {
          cov_1fgm2o0a69.b[44][0]++;
          cov_1fgm2o0a69.s[111]++;
          isRight = !isRight;
        } else {
          cov_1fgm2o0a69.b[44][1]++;
        }

        cov_1fgm2o0a69.s[112]++;
        return isRight;
      }
    }, {
      key: "resetPosition",
      value: function resetPosition(clean) {
        cov_1fgm2o0a69.f[14]++;

        var _ref8 = (cov_1fgm2o0a69.s[113]++, this.props),
            focus = _ref8.focus,
            parentElement = _ref8.parentElement;

        cov_1fgm2o0a69.s[114]++;

        if ((cov_1fgm2o0a69.b[46][0]++, !this.el) || (cov_1fgm2o0a69.b[46][1]++, !focus) || (cov_1fgm2o0a69.b[46][2]++, this.ajustdoc) && (cov_1fgm2o0a69.b[46][3]++, !clean)) {
          cov_1fgm2o0a69.b[45][0]++;
          cov_1fgm2o0a69.s[115]++;
          return;
        } else {
          cov_1fgm2o0a69.b[45][1]++;
        }

        var width = (cov_1fgm2o0a69.s[116]++, this.el.offsetWidth);
        var pos = (cov_1fgm2o0a69.s[117]++, (cov_1fgm2o0a69.b[47][0]++, parentElement) && (cov_1fgm2o0a69.b[47][1]++, parentElement.getBoundingClientRect()) || (cov_1fgm2o0a69.b[47][2]++, {
          left: 0,
          right: 0
        }));
        var containerRect = (cov_1fgm2o0a69.s[118]++, (cov_1fgm2o0a69.b[48][0]++, this.containerRect) || (cov_1fgm2o0a69.b[48][1]++, {
          left: 0,
          width: 0
        }));
        var containerScroll = (cov_1fgm2o0a69.s[119]++, (cov_1fgm2o0a69.b[49][0]++, this.containerScroll) || (cov_1fgm2o0a69.b[49][1]++, {
          left: 0
        }));
        var overdoc;
        cov_1fgm2o0a69.s[120]++;

        if (this.isRight()) {
          cov_1fgm2o0a69.b[50][0]++;
          cov_1fgm2o0a69.s[121]++;

          if ((cov_1fgm2o0a69.b[52][0]++, isRTL()) && (cov_1fgm2o0a69.b[52][1]++, containerScroll.left)) {
            cov_1fgm2o0a69.b[51][0]++;
            cov_1fgm2o0a69.s[122]++;
            // this condition  the style left: 0 will not meet expect so not set overdoc
            overdoc = false;
          } else {
            cov_1fgm2o0a69.b[51][1]++;
            cov_1fgm2o0a69.s[123]++;
            overdoc = pos.right - width < containerRect.left;
          }
        } else {
          cov_1fgm2o0a69.b[50][1]++;
          cov_1fgm2o0a69.s[124]++;

          if ((cov_1fgm2o0a69.b[54][0]++, !isRTL()) && (cov_1fgm2o0a69.b[54][1]++, containerScroll.left)) {
            cov_1fgm2o0a69.b[53][0]++;
            cov_1fgm2o0a69.s[125]++;
            // this condition  the style right: 0 will not meet expect so not set overdoc
            overdoc = false;
          } else {
            cov_1fgm2o0a69.b[53][1]++;
            cov_1fgm2o0a69.s[126]++;
            overdoc = pos.left - containerRect.left + width + containerScroll.left > ((cov_1fgm2o0a69.b[55][0]++, containerRect.width) || (cov_1fgm2o0a69.b[55][1]++, docSize.width));
          }
        }

        cov_1fgm2o0a69.s[127]++;

        if (this.state.overdoc === overdoc) {
          cov_1fgm2o0a69.b[56][0]++;
          cov_1fgm2o0a69.s[128]++;
          return;
        } else {
          cov_1fgm2o0a69.b[56][1]++;
        }

        cov_1fgm2o0a69.s[129]++;
        this.ajustdoc = true;
        cov_1fgm2o0a69.s[130]++;
        this.setState({
          overdoc: overdoc
        });
      }
    }, {
      key: "handleRef",
      value: function handleRef(ref) {
        cov_1fgm2o0a69.f[15]++;
        cov_1fgm2o0a69.s[131]++;
        this.el = ref;
      }
    }, {
      key: "renderList",
      value: function renderList() {
        cov_1fgm2o0a69.f[16]++;

        var _ref9 = (cov_1fgm2o0a69.s[132]++, this.props),
            parentElement = _ref9.parentElement,
            absolute = _ref9.absolute,
            focus = _ref9.focus,
            rootClass = _ref9.rootClass,
            position = _ref9.position,
            scrollLeft = _ref9.scrollLeft,
            scrollTop = _ref9.scrollTop,
            scrollElement = _ref9.scrollElement,
            _ref9$style = _ref9.style,
            style = _ref9$style === void 0 ? (cov_1fgm2o0a69.b[57][0]++, {}) : _ref9$style,
            zIndex = _ref9.zIndex,
            getResetPosition = _ref9.getResetPosition,
            ignore = _ref9.autoAdapt,
            props = _objectWithoutProperties(_ref9, ["parentElement", "absolute", "focus", "rootClass", "position", "scrollLeft", "scrollTop", "scrollElement", "style", "zIndex", "getResetPosition", "autoAdapt"]);

        cov_1fgm2o0a69.s[133]++;

        if (zIndex !== undefined) {
          cov_1fgm2o0a69.b[58][0]++;
          var parsed = (cov_1fgm2o0a69.s[134]++, parseInt(zIndex, 10));
          cov_1fgm2o0a69.s[135]++;

          if (!Number.isNaN(parsed)) {
            cov_1fgm2o0a69.b[59][0]++;
            cov_1fgm2o0a69.s[136]++;
            style.zIndex = parsed;
          } else {
            cov_1fgm2o0a69.b[59][1]++;
          }
        } else {
          cov_1fgm2o0a69.b[58][1]++;
        }

        var mergeStyle = (cov_1fgm2o0a69.s[137]++, Object.assign({}, style, this.state.overdoc ? (cov_1fgm2o0a69.b[60][0]++, getOverDocStyle(this.isRight())) : (cov_1fgm2o0a69.b[60][1]++, undefined)));
        cov_1fgm2o0a69.s[138]++;
        return (
          /*#__PURE__*/
          React.createElement(List, Object.assign({
            getRef: this.handleRef
          }, props, {
            focus: focus,
            style: mergeStyle,
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 275,
              columnNumber: 14
            }
          }))
        );
      }
    }, {
      key: "render",
      value: function render() {
        var _this3 = this;

        cov_1fgm2o0a69.f[17]++;

        var _ref10 = (cov_1fgm2o0a69.s[139]++, this.props),
            autoAdapt = _ref10.autoAdapt;

        cov_1fgm2o0a69.s[140]++;
        setTimeout(function () {
          cov_1fgm2o0a69.f[18]++;
          cov_1fgm2o0a69.s[141]++;

          _this3.resetPosition(autoAdapt);
        });
        cov_1fgm2o0a69.s[142]++;

        if (!this.props.absolute) {
          cov_1fgm2o0a69.b[61][0]++;
          cov_1fgm2o0a69.s[143]++;
          return this.renderList();
        } else {
          cov_1fgm2o0a69.b[61][1]++;
        }

        cov_1fgm2o0a69.s[144]++;

        if (!this.container) {
          cov_1fgm2o0a69.b[62][0]++;
          cov_1fgm2o0a69.s[145]++;
          return null;
        } else {
          cov_1fgm2o0a69.b[62][1]++;
        }

        var _ref11 = (cov_1fgm2o0a69.s[146]++, this.props),
            parentElement = _ref11.parentElement,
            rootClass = _ref11.rootClass,
            absolute = _ref11.absolute,
            position = _ref11.position,
            scrollLeft = _ref11.scrollLeft,
            scrollTop = _ref11.scrollTop,
            scrollElement = _ref11.scrollElement,
            autoClass = _ref11.autoClass,
            zIndex = _ref11.zIndex,
            getResetPosition = _ref11.getResetPosition,
            value = _ref11.value,
            ignore = _ref11.autoAdapt,
            props = _objectWithoutProperties(_ref11, ["parentElement", "rootClass", "absolute", "position", "scrollLeft", "scrollTop", "scrollElement", "autoClass", "zIndex", "getResetPosition", "value", "autoAdapt"]);

        var mergeClass = (cov_1fgm2o0a69.s[147]++, classnames(listClass('absolute-wrapper'), rootClass, autoClass));

        var _ref12 = (cov_1fgm2o0a69.s[148]++, props.focus ? (cov_1fgm2o0a69.b[63][0]++, this.getStyle()) : (cov_1fgm2o0a69.b[63][1]++, {
          style: this.lastStyle,
          focus: undefined
        })),
            focus = _ref12.focus,
            style = _ref12.style;

        cov_1fgm2o0a69.s[149]++;
        this.element.className = mergeClass;
        var mergeStyle = (cov_1fgm2o0a69.s[150]++, Object.assign({}, style, props.style, this.state.overdoc ? (cov_1fgm2o0a69.b[64][0]++, getOverDocStyle(this.isRight())) : (cov_1fgm2o0a69.b[64][1]++, undefined)));
        cov_1fgm2o0a69.s[151]++;

        if ((cov_1fgm2o0a69.b[66][0]++, zIndex) || (cov_1fgm2o0a69.b[66][1]++, typeof zIndex === 'number')) {
          cov_1fgm2o0a69.b[65][0]++;
          cov_1fgm2o0a69.s[152]++;
          mergeStyle.zIndex = parseInt(zIndex, 10);
        } else {
          cov_1fgm2o0a69.b[65][1]++;
        }

        cov_1fgm2o0a69.s[153]++;
        return (
          /*#__PURE__*/
          ReactDOM.createPortal(
          /*#__PURE__*/
          React.createElement(List, Object.assign({
            getRef: this.handleRef
          }, props, {
            focus: focus,
            style: mergeStyle,
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 315,
              columnNumber: 9
            }
          })), this.element)
        );
      }
    }]);

    return AbsoluteList;
  }(Component);

  cov_1fgm2o0a69.s[154]++;
  return compose(scrollConsumer, zIndexConsumer)(AbsoluteList);
}